import { render, staticRenderFns } from "./InputView.vue?vue&type=template&id=22f092d2&scoped=true&"
import script from "./InputView.vue?vue&type=script&lang=js&"
export * from "./InputView.vue?vue&type=script&lang=js&"
import style0 from "./InputView.vue?vue&type=style&index=0&id=22f092d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f092d2",
  null
  
)

export default component.exports